{
	"ru": {
		"label": "RU",
		"native": "Русский",
		"og": "ru_RU",
		"rtl": false
	},
	"en": {
		"label": "EN",
		"native": "English",
		"og": "en_US",
		"rtl": false,
		"default": true
	},
	"zh": {
		"label": "中文",
		"native": "中文",
		"og": "zh_CN",
		"rtl": false
	},
	"fa": {
		"label": "فارسی",
		"native": "فارسی",
		"og": "fa_IR",
		"rtl": true
	},
	"ar": {
		"label": "عربي",
		"native": "العربية",
		"og": "ar_AE",
		"rtl": true
	},
	"tr": {
		"label": "TR",
		"native": "Türkçe",
		"og": "tr_TR",
		"rtl": false
	},
	"es": {
		"label": "ES",
		"native": "Español",
		"og": "es_ES",
		"rtl": false
	},
	"uk": {
		"label": "УКР",
		"native": "Українська",
		"og": "uk_UA",
		"rtl": false
	},
	"vi": {
		"label": "VI",
		"native": "Tiếng Việt",
		"og": "vi_VN",
		"rtl": false
	},
	"ur": {
		"label": "اردو",
		"native": "اردو",
		"og": "ur_PK",
		"rtl": true
	},
	"am": {
		"label": "አማርኛ",
		"native": "አማርኛ",
		"og": "am_ET",
		"rtl": false
	},
	"my": {
		"label": "မြန်မာ",
		"native": "မြန်မာ",
		"og": "my_MM",
		"rtl": false
	},
	"az": {
		"label": "AZ",
		"native": "Azərbaycanca",
		"og": "az_AZ",
		"rtl": false
	},
	"tk": {
		"label": "TK",
		"native": "Türkmençe",
		"og": "tk_TM",
		"rtl": false
	},
	"sw": {
		"label": "SW",
		"native": "Kiswahili",
		"og": "sw_KE",
		"rtl": false
	},
	"so": {
		"label": "SO",
		"native": "Soomaali",
		"og": "so_SO",
		"rtl": false
	}
}
